import { StreamType } from '../../../api/models/Shared.types';
import { Backend } from '../../../api/Backend';
import { ChannelModel } from '../../../api/EpgApi.types';
import { Recording } from '../../../api/user/RecordingApi.types';
import { timeStringToMs } from '../../../Business/utility/DateFormatter';
import { IRibbon2Schedule } from '../../../api/models/AndromeTV.types';

export function authShowStartRecord(
  backend: Backend,
  schedule: IRibbon2Schedule | undefined,
  channel: ChannelModel | undefined,
  recording: Recording
) {
  const isInRecordingWindow = checkInRecordingWindow(schedule, recording, channel);
  const channelHasRightsForCustomer = channel && channel.hasOneOfCustomerRights([StreamType.NPVR]);
  return isInRecordingWindow && channelHasRightsForCustomer && recording === undefined && backend.sessionInfo?.npvr;
}

export function authShowDeleteRecord(recording: Recording | undefined) {
  return recording && (recording.isRecorded() || recording.isInProgress());
}

export function authShowCancelRecord(recording: Recording | undefined) {
  return recording && recording.isPlanned();
}

function checkInRecordingWindow(
  schedule: IRibbon2Schedule | undefined,
  recording: Recording | undefined,
  channel: ChannelModel | undefined
) {
  if (!schedule && recording) {
    schedule = {
      id: recording.schedule,
      published: { start: recording.start, end: recording.end },
    };
  }

  if (schedule) {
    const recordingStart = new Date();

    const now = new Date().getTime();

    if (channel?.npvrRecordHours) {
      recordingStart.setHours(recordingStart.getHours() - channel.npvrRecordHours);
      return (
        timeStringToMs(schedule.published.end) >= now ||
        (timeStringToMs(schedule.published.start) <= now &&
          timeStringToMs(schedule.published.start) > recordingStart.getTime())
      );
    } else {
      return timeStringToMs(schedule.published.end) >= now;
    }
  }

  return false;
}
